import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.number.constructor";
import { buryingPoint } from "@/util/buryingPoint";
export default {
  props: {
    promoter: Object,
    commReturnType: Number | String
  },
  data: function data() {
    return {
      isAPP: window.mobileEnv == "app" ? true : false,
      //是否在云客赞app打开页面
      commReturnTypeObj: {
        1: "（支付返）",
        2: "（消费返）",
        3: "（7天返）"
      }
    };
  },
  computed: {
    backShow: function backShow() {
      if (this.isApp) {
        return this.promoter.maxCommission != this.promoter.originalAppSellComm;
      } else {
        return this.promoter.maxCommission != this.promoter.originalSellComm;
      }
    },
    sellComm: function sellComm() {
      var comm = '';
      if (this.promoter.isExcellence) {
        comm = this.isAPP ? this.promoter.appSellComm : this.promoter.sellComm;
      } else {
        comm = this.isAPP ? this.promoter.originalAppSellComm : this.promoter.originalSellComm;
      }
      return comm;
    },
    stringReturntype: function stringReturntype() {
      console.log('----!!this.promoter!!----', this.promoter);
      if (!this.commReturnType) {
        return '';
      }
      if (this.commReturnType == 1) {
        return '（支付返）';
      }
      if (this.commReturnType == 2) {
        return '（消费返）';
      }
      return '（7天返）';
    }
  },
  methods: {
    handlePointer: function handlePointer() {
      buryingPoint('SX-DJYJSR', '点击佣金收入', {}, '');
    },
    //判断奖励字段是否需要显示
    getIsShow: function getIsShow(value) {
      if (!value || typeof value != "string") {
        return false;
      }
      var numStr = value.replace(/[^0-9]+/g, '');
      if (numStr && numStr != 0) {
        return true;
      } else {
        return false;
      }
    }
  }
};